module.exports = __webpack_public_path__ + "static/img/render3.50f505f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/render3.jpg
// module id = f4sK
// module chunks = 0